'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeTimeOnPageTriggerAction = undefined;

var _reduxActions = require('redux-actions');

var _timeOnPageTriggerActionTypes = require('../constants/timeOnPageTriggerActionTypes');

var removeTimeOnPageTriggerAction = exports.removeTimeOnPageTriggerAction = (0, _reduxActions.createAction)(_timeOnPageTriggerActionTypes.REMOVE_TIME_ON_PAGE_TRIGGER);